import calendarStyles from '~/styles/calendar/calendar.module.css';

type Props = {
  day: string;
};

export default function DayHead({
  day,
}: Props) {
  return (
    <div
      key={day}
      className={calendarStyles.calendarDayHead}
    >
      {day}
    </div>
  );
}
